<template>
  <div id="header__main">
    <div class="col-1">
    </div>

    <div class="col-10">
      {{ selectedPlace.name }}({{ todyaTryCount }})
    </div>

    <div class="col-1">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title>
              <router-link to="/">
                <v-icon >mdi-home</v-icon>Home
              </router-link>
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>タイトル1</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>タイトル2</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>
              <button
                v-on:click="deleteResult">
                削除
              </button>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'

export default {
  computed :{
    todyaTryCount() {
      // 履歴なしチェック
      if (!JSON.parse(this.getStorageData())) return 0
      const today = moment().format('YYYY/MM/DD')
      return JSON.parse(this.getStorageData()).filter(item => item.date === today).length
    },
    ...mapState({
      selectedPlace: state => state.places.selectedPlace
    }),
  },
  methods: {
    ...mapGetters({
      getStorageData: 'task/getStorageData',
    }),

    // 結果の削除
    deleteResult () {
      localStorage.clear()
      this.storageData = []
      this.$emit('updateTryCount')
    }
  },
}

</script>

<style scoped lang="scss">
@import "colors.scss";

#header__main {
  width: 100vw;
  background-color: $indigo;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.menu {
  position: fixed;
  z-index: 100;
  top: 44px;
  right: 0px;
  width: 60vw;
  transition: .5s;
}
.shadow {
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  z-index: 5;
  background-color: rgba(0, 0, 0, 0.4);
}

.v-btn { color: rgba(255, 255, 255, 1) !important; }
</style>